import React from "react";
import NFLookupEmptyForms from "../../../Shared/NewForms/NFLookupEmptyForms";

function BankAccountDetailSkeleton() {
  return (
    <>
      <NFLookupEmptyForms />
    </>
  );
}

export default BankAccountDetailSkeleton;
